module.exports = __webpack_public_path__ + "static/media/mathworks.4e11021b.png";